import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class NotificationIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">

				<path fill="currentColor" d="M953.907 837.030c-108.82-49.144-112.96-260.086-113.040-265.408v-141.517c0-136.203-83.229-253.323-201.5-303.191-0.254-70.025-57.287-126.914-127.364-126.914-70.079 0-127.11 56.892-127.366 126.911-118.266 49.868-201.497 166.989-201.497 303.191v141.517c-0.077 5.322-4.22 216.264-113.043 265.408-12.397 5.6-19.21 19.095-16.344 32.393 2.863 13.3 14.624 22.799 28.229 22.799h275.879c5.655 31.112 20.366 60.055 42.866 83.498 29.883 31.135 69.403 48.282 111.272 48.282 41.872 0 81.391-17.147 111.272-48.282 22.503-23.445 37.214-52.39 42.866-83.498h275.879c13.605 0 25.364-9.497 28.23-22.799 2.87-13.299-3.94-26.791-16.337-32.39zM810.558 735.976c11.44 34.682 27.638 69.512 50.608 98.495h-698.332c22.966-28.98 39.165-63.808 50.604-98.495h597.119zM512.002 57.75c31.699 0 58.5 21.3 66.886 50.333-21.604-4.481-43.975-6.843-66.886-6.843s-45.282 2.361-66.886 6.843c8.388-29.032 35.189-50.333 66.886-50.333zM240.889 571.796v-141.696c0-149.49 121.619-271.109 271.112-271.109s271.112 121.619 271.112 271.109v141.932c0.038 4.344 0.714 49.994 12.219 106.19h-566.67c11.512-56.25 12.191-101.98 12.226-106.426zM512.002 966.254c-44.074 0-82.539-31.778-94.886-74.033h189.769c-12.347 42.255-50.805 74.033-94.882 74.033z"></path>
				<path fill="currentColor" d="M512.002 199.505c-124.235 0-225.31 101.070-225.31 225.305 0 15.947 12.929 28.876 28.876 28.876s28.876-12.929 28.876-28.876c0-92.389 75.165-167.554 167.559-167.554 15.947 0 28.876-12.929 28.876-28.876-0.002-15.949-12.931-28.875-28.878-28.875z"></path>

			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}
